module.exports = __webpack_public_path__ + "img/Paraguay.54d548fc.png";